import React from 'react';
import { roadMapData } from '../../data/disclosureRequest';
import type { Density, RoadMapSection } from '../../types/disclosure';
import { SectionCard } from './SectionCard';
import { FieldGroupBlock } from './FieldGroupBlock';
import { NotApplicableGroups } from './NotApplicableGroups';
import { NotesPanel } from './NotesPanel';
interface RoadMapTabProps {
  density: Density;
  showApiNames: boolean;
}
export function RoadMapTab({
  density,
  showApiNames
}: RoadMapTabProps) {
  const {
    sections,
    notesSection
  } = roadMapData;
  const renderSection = (section: RoadMapSection, columns: 1 | 2 | 3) => {
    const applicable = section.groups.filter(group => group.applicable !== false);
    const notApplicable = section.groups.filter(group => group.applicable === false);
    return <SectionCard key={section.id} id={section.id} title={section.title} description={section.description} data-id="element-53" data-mp="34v7css9w25l3">
        {applicable.map(group => <FieldGroupBlock key={group.id} group={group} density={density} showApiNames={showApiNames} columns={columns} data-id="element-54" data-mp="2glc6c51pk9va" />)}
        <NotApplicableGroups groups={notApplicable} sectionId={section.id} data-id="element-55" data-mp="2qb47xj886399" />
      </SectionCard>;
  };
  return <main className="min-h-full w-full bg-slate-100 px-4 py-5 sm:px-6" data-id="element-56" data-mp="2ud8uxz4641mx">
      <div className="mx-auto grid max-w-[1520px] items-stretch gap-4 xl:grid-cols-12" data-id="element-57" data-mp="1xmgdoy5i03jk">
        <div className="xl:col-span-5" data-id="element-58" data-mp="1xot5e3125s9t">
          <SectionCard id={notesSection.id} title={notesSection.title} description={notesSection.description} fill data-id="element-59" data-mp="22krobb3mai2u">
            <NotesPanel notes={notesSection.notes} showApiNames={showApiNames} data-id="element-60" data-mp="2bm7vl9z4y42u" />
          </SectionCard>
        </div>

        <div className="space-y-4 xl:col-span-7" data-id="element-61" data-mp="3i2tiywf6hp32">
          {sections.map(section => renderSection(section, 2))}
        </div>
      </div>
    </main>;
}